import { SystemEntity } from '@erp/shared-types';

/** What the related records' lookups returned so far. */
export type RelatedRecords = {
  invoiceLoading: boolean;
  invoiceNumber?: string | null;
  emailLoading: boolean;
  emailSubject?: string | null;
  /** Absent when the Workbook is private to someone else. */
  workbookName?: string | null;
};

/**
 * The "Related to" badge label: the record's own name where it has one and
 * the viewer could load it, else the entity type's display name.
 */
export function relatedEntityLabel(
  entityType: SystemEntity,
  typeName: string,
  records: RelatedRecords,
): string {
  switch (entityType) {
    case SystemEntity.WORKBOOK:
      return records.workbookName ?? typeName;
    case SystemEntity.AP_INVOICE:
      if (records.invoiceLoading || !records.invoiceNumber) return typeName;
      return `${typeName} ${records.invoiceNumber}`;
    case SystemEntity.INBOUND_EMAIL:
      if (records.emailLoading) return typeName;
      return records.emailSubject?.trim() || typeName;
    default:
      return typeName;
  }
}
